import { render, staticRenderFns } from "./DetailChatAdmin.vue?vue&type=template&id=3d333d9e&scoped=true&"
import script from "./DetailChatAdmin.vue?vue&type=script&lang=js&"
export * from "./DetailChatAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DetailChatAdmin.vue?vue&type=style&index=0&id=3d333d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d333d9e",
  null
  
)

export default component.exports